import ProFormUploadButton from './UploadButton';
import { withWrap } from '../../utils/hoc';
export default withWrap(ProFormUploadButton);
